<template>
  <div
    class="create-instrumental-edit-content-box"
    :class="{
      [`create--${createRenderType}`]: true,
      'create-instrumental-edit--open':
        props.renderType == 'create'
          ? bgmCreate_createEditOpenState == 'max' ||
            bgmCreate_createEditOpenState == 'playermax'
          : nobgmCreate_createEditOpenState == 'max' ||
            nobgmCreate_createEditOpenState == 'playermax',
      'create-instrumental-edit--min':
        props.renderType == 'create'
          ? bgmCreate_createEditOpenState == 'min'
          : nobgmCreate_createEditOpenState == 'min',
      'create-instrumental-edit--playerMin':
        props.renderType == 'create'
          ? bgmCreate_createEditOpenState == 'playermin'
          : nobgmCreate_createEditOpenState == 'playermin',
    }"
  >
    <div
      class="create-instrumental-edit"
      :class="{
        'create-instrumental-edit--easy':
          renderData.bgmCreateEditMode == 'easy',
        'create-instrumental-edit--hard':
          renderData.bgmCreateEditMode == 'hard',
      }"
    >
      <div
        class="create-instrumental-edit-content flex"
        :style="{
          height: createRenderType == 'mobile' ? '100%' : '100%',
        }"
      >
        <div class="create-mode-switch-box flex-row-center">
          <ModeSwitch :isSimilar="!!props.similarData"></ModeSwitch>
          <div class="model-box"><PersonalModel :canSelected="false"></PersonalModel></div>
          <div class="create-instrumental-edit-title-close" @click.stop>
            <IconButton
              v-if="renderData.linkurl != ''"
              size="40px"
              icoSize="20px"
              :disable="props.disableClose"
              backgroundColor="rgb(255, 255, 255, 0.1)"
              hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
              @onClick="closeCreateEdit"
            >
              <img src="@/assets/img/close-ico.png" />
            </IconButton>
          </div>
        </div>

        <div
          class="create-instrumental-edit-box height-0 flex flex1"
          ref="refCreateEditAdvance"
        >
          <div class="create-instrumental-edit-easy flex1">
            <CreateEditEasy :similarData="props.similarData"></CreateEditEasy>
          </div>
          <div class="create-instrumental-edit-reference">
            <CreateAavance :similarData="props.similarData"></CreateAavance>
          </div>
        </div>
      </div>
      <div class="create-min-button-box" v-if="!globalPlayerOpened && false">
        <div class="create-min-button" @click="openCreateEdit">
          <i class="fn-inline"></i>
          <span class="fn-inline"> {{ $$t("create.create") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import Button from "@/components/basic/button/Button.vue";
import IconButton from "@/components/basic/button/IconButton.vue";
import CreateEditEasy from "@/page/instrumental/createEasyMode/createEditEasy.vue";
import ModeSwitch from "@/page/instrumental/modeSwitch.vue";
import CreateAavance from "@/page/instrumental/createAdvance/createAavance.vue";
import PersonalModel from "../create/personalModel/index.vue";
import globleConfig from "@/config/config.js";
import tools from "@/utils/tools.js";
import {
  $$language,
  $$t,
  $$registLanguageChangeListener,
  $$removeLanguageChangeListener,
} from "@/i18n/i18n.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
const userDataStore = useUserDataStore();

const createLayoutStore = useCreateLayoutStore();

const {
  createRenderType,
  bgmCreate_createEditOpenState,
  nobgmCreate_createEditOpenState,
  globalPlayerOpened,
  bgmCreateEditMode,
  createEditGuidTourVisible,
  vocalCornerMarkVisible,
} = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const props = defineProps({
  similarData: {
    type: Object,
    default: () => {
      return null;
    },
  },
  renderType: {
    type: String,
    default: "create",
  },
  initClose: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits([]);

const renderData = reactive({
  bgmCreateEditMode: "hard",
});

const closeCreateEdit = (e) => {
  e ??= window.event;
  e.preventDefault();
  createLayoutStore.toggleBgmCreateEditOpenState(false);
};

watch(
  () => {
    return renderData.createEditOpenState;
  },
  () => {
    createLayoutStore.setCreateEditOpenState(
      renderData.createEditOpenState,
      "createEdit"
    );
  }
);

const initPoint = () => {
  if (createRenderType.value == "pc") {
    globalProperties.logPageMounted("create_instrumental_tab_stare", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
      tab_stare: bgmCreateEditMode.value == "hard" ? "advanced" : "basic",
    });
  } else {
    if (
      bgmCreate_createEditOpenState.value == "max" ||
      bgmCreate_createEditOpenState.value == "playermax"
    ) {
      globalProperties.logPageMounted("create_instrumental_tab_stare", {
        type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
        tab_stare: bgmCreateEditMode.value == "hard" ? "advanced" : "basic",
      });
    }
  }
};

const debounceInitPoint = tools.debounce(initPoint, 1000);


watch(
  () => {
    return bgmCreateEditMode.value;
  },
  () => {
    if (!props.similarData) {
      renderData.bgmCreateEditMode = bgmCreateEditMode.value;
    }
  }
);

watch(
  () => {
    return renderData.bgmCreateEditMode;
  },
  () => {
    debounceInitPoint();
  }
);

watch(
  () => {
    return bgmCreate_createEditOpenState.value;
  },
  () => {
    debounceInitPoint();
  }
);

onMounted(async () => {
  if (!props.similarData) {
    renderData.bgmCreateEditMode = createLayoutStore.bgmCreateEditMode;
  }
  debounceInitPoint(true);
});

onUnmounted(() => {});

defineExpose({
  openEdit() {
    renderData.createEditOpenState = "max";
  },
});
</script>
<style lang="scss">
.create-instrumental-edit-content-box {
  height: 100%;
  overflow-y: scroll;
  width: 421px;
  min-width: 421px;
  .create-instrumental-edit {
    display: flex;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    height: 100%;
    flex-direction: column;
    min-height: 400px;
    .create-instrumental-edit-content {
      flex-direction: column;
    }
    .create-mode-switch-box {
      padding: 20px 20px 20px 0;
      justify-content: space-between;
      .create-instrumental-edit-title-close {
        display: none;
      }
      .create-mode-switch {
        width: 0;
        flex: 1 1 0;
        max-width: 244px;
      }
      .model-box {
        margin: 0 0px 0 12px;
      }
    }
    .create-instrumental-edit-box {
      flex-direction: column;
      margin: 0 20px 20px 0;
    }

    .create-instrumental-edit-reference {
      height: 100%;
      position: relative;
    }

    .create-instrumental-edit-easy {
      display: block;
      width: 300px;
      height: 100%;
      padding: 0px 0 0px 0;
    }
    &.create-instrumental-edit--easy {
      .create-instrumental-edit-easy {
        display: block;
        width: 400px;
      }
      .create-instrumental-edit-box {
        margin: 0 8px 20px 0;
      }
      .create-instrumental-edit-reference {
        display: none;
      }
    }
    &.create-instrumental-edit--hard {
      .create-instrumental-edit-easy {
        display: none;
      }
    }
  }
  .create-result {
    height: 100%;
  }
  .create-instrumental-edit-title {
    padding: 0px 0 0 0;
    .create-instrumental-edit-title-close {
      display: none;
    }
  }

  .create-min-button-box {
    position: absolute;
    bottom: 60px;
    left: 16px;
    right: 16px;
    height: 56px;
    z-index: 2;
    display: none;
    .create-min-button {
      width: 100%;
      height: 100%;
      background-image: url("@/assets/img/create-btn-bg.png");
      background-size: 100% 100%;
      border-radius: 56px;
      line-height: 56px;
      text-align: center;
      i {
        width: 24px;
        height: 24px;
        background-image: url("@/assets/img/music-ico-white.png");
        background-size: 100% 100%;
      }
      span {
        font-family: HarmonyOS Sans SC;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        color: #ffffff;
        margin-left: 5px;
      }
    }
  }
  .create-min-button-player-box {
    display: none;
    .create-min-button-player-player {
      height: 56px;
    }
    .create-min-button-player-button {
      height: 56px;
      width: 56px;
      background-image: url("@/assets/img/create-btn-bg.png");
      background-size: 100% 100%;
      border-radius: 48px;
      i {
        width: 24px;
        height: 24px;
        background-image: url("@/assets/img/music-ico-white.png");
        background-size: 100% 100%;
      }
    }
  }
}
.create-instrumental-edit-content-box.create--mobile {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  min-height: 100%;
  background: rgba(71, 74, 74, 0.5);
  backdrop-filter: blur(100px);
  overflow-y: unset;
  min-width: 100%;
  .create-instrumental-edit {
    height: 100%;
    flex-direction: column;
    width: 100%;
    border-right: none;
    height: 100%;

    .create-instrumental-edit-box {
      flex-direction: column;
      margin: 0 0px 0px 0;
    }

    .create-mode-switch-box {
      padding: 20px 0 16px 0;
      .create-instrumental-edit-title-close {
        display: block;
      }
      .model-box {
        margin: 0 8px 0 12px;
        width: 30px;
      }
    }
    &.create-instrumental-edit--easy {
      .create-instrumental-edit-easy {
        display: block;
        width: 100%;
        margin: 0 0;
      }
      .create-instrumental-edit-reference {
        display: none;
      }
    }
    &.create-instrumental-edit--hard {
      .create-instrumental-edit-easy {
        display: none;
        margin: 0 0;
      }
    }
  }
  .create-instrumental-edit-content {
    background-image: url(/src/assets/img/main-bg-mobile-wp.webp);
    background-size: 100% 100%;
    padding: 0 16px;
  }
  .create-instrumental-edit-title {
    display: flex;
    font-family: HarmonyOS Sans SC;
    font-size: 24px;
    line-height: 40px;
    height: 0;
    font-weight: 500;
    color: #ffffff;
    padding: 0px 0 0 0;
    align-items: center;
    .create-instrumental-edit-title-close {
      display: block;
    }
  }

  .create-instrumental-edit-area {
    padding: 0 0 0 0;
  }
  &.create-instrumental-edit--open {
    transform: translateY(0);
    .create-min-button-box {
      display: none;
    }
  }
  &.create-instrumental-edit--min {
    transform: translateY(100%);
    .create-min-button-box {
      display: block;
    }
    .create-min-button {
      display: block;
    }
    .create-min-button-player-box {
      display: none;
    }
  }
  &.create-instrumental-edit--playerMin {
    transform: translateY(100%);
    .create-min-button-box {
      display: block;
    }
    .create-min-button {
      display: none;
    }
    .create-min-button-player-box {
      display: flex;
    }
  }
}
.main-page-bottom-player-visible--true {
  &.main-page--pc {
    .create-instrumental-edit-content-box {
      padding-bottom: 64px;
    }
    .mescroll:after {
      content: "";
      display: block;
      width: 100%;
      height: 64px;
    }
    .create-instrumental-edit {
      .mescroll:after {
        content: "";
        display: block;
        width: 100%;
        height: 0;
      }
    }
  }
  &.main-page--mobile {
    .mescroll:after {
      content: "";
      display: block;
      width: 100%;
      height: 80px;
    }
    .create-instrumental-edit-ideas-items {
      .mescroll:after {
        content: "";
        height: 0;
      }
    }
  }
}
.main-page-bottom-player-visible--false {
  &.main-page--mobile {
    .mescroll:after {
      content: "";
      display: block;
      width: 100%;
      height: 0;
    }
    .create-instrumental-edit {
      .mescroll:after {
        content: "";
        display: block;
        width: 100%;
        height: 0;
      }
    }
  }
}
</style>
